import React, { useEffect } from 'react'

const GoogleAd = ({ width = '100%', height = '100%', location = 'not set' }) => {
  // initialise this advert on component load
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch (error) {
      console.debug('*** Google adsense component error', error)
    }
  }, [])

  // const height = 500;
  const style = {
    maxHeight: height,
    height: height,
    width: width,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '90px',
    minWidth: '200px',
    margin: 'auto',
    align: 'center'
  }
  const placeholderStyle = {
    background: '#ffc',
    height: height,
    width: width,
    padding: '1rem',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1rem solid #ee7',
    color: 'rgba(0,0,0,0.25)',
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.2rem'
  }
  const adStyle = {
    display: 'block',
    height: height,
    maxHeight: height,
    width: width
  }

  if (process.env.REACT_APP_GOOGLE_ADSENSE_USE_PLACEHOLDERS !== 'true') {
    return (
      <div style={style}>
        <ins
          className='adsbygoogle'
          style={adStyle}
          data-ad-client={process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT}
          data-ad-slot={process.env.REACT_APP_GOOGLE_ADSENSE_SLOT}
          data-ad-format='auto'
          data-full-width-responsive='true'
        />
      </div>
    )
  } else {
    return (
      <div style={placeholderStyle}>
        PLACEHOLDER GOOGLE ADSENSE ADVERT <br />{width} * {height}<br />{location}
      </div>
    )
  }
}

export default GoogleAd
